import React, { useState, useEffect } from "react";
import t from "../../../helpers/t";

import { useSelector } from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils"; // necessary to communicate with inbooma-react

import { moment, _, $ } from "../../../../../vendor";

import Notification from "../../../components/Notification";
import FormItem from "../../../components/FormItem";
import Listing from "../../../components/Listing";
import {
  in_array,
  setItem,
  getItem,
  getDuration,
  getDurationReverse,
} from "../../../../utils/Helper";
import { addAbonnement, editAbonnement } from "../Util/API";
import AbonnementCard from "./abonnementCard/abonnementCard";
import { getIntervalString, getMinDuration } from "./abonnementCard/abonnementTimes";
import ImageUpload from "../../../components/ImageUpload";

const ItemView = (props: any) => {
  const {
    dispatch,
    params,
    abo,
    abonnementsActions,
    requestPath,
    showNotification,
    temp,
    setTemp,
    membershipTypes,
  } = props;
  const [abonnement, setAbonnement] = useState(
    typeof abo.id === "undefined"
      ? {
          // make a local copy of task or initialize a new task
          description: "",
          description_long: null,
          intervalAmount: null,
          intervalUnit: null,
          duration: null,
          minDuration: null,
          client_id: Biscuit.get("user.client_id"),
          membership_types_id: null,
          amount: null,
          image: null,
        }
      : abo,
  );

  const _addAbonnement = useSelector((state: any) => state.abonnements_data.addAbonnement); // used for after save process
  const _editAbonnement = useSelector((state: any) => state.abonnements_data.editAbonnement);
  const [abonnementPending, setAbonnementPending]: any = useState(null);
  const [listing, setListing] = useState(abonnement.description_long);
  const inner = listing !== null ? JSON.parse(listing) : null;
  const outer = inner !== null ? inner.description : "";
  const [image, setImage] = useState(abonnement.image);
  const [notification, setNotification]: any = useState({
    message: "",
    show: false,
  });

  useEffect(() => {
    if (_addAbonnement.success === "" || !abonnementPending) {
      return;
    }
    if (_addAbonnement.success === true) {
      showNotification("success", _addAbonnement.id);
      setItem("abonnemment", "");
      close();
    } else {
      showNotification("warning", null, t(_addAbonnement.message));
    }
    setAbonnementPending(false);
  }, [_addAbonnement]);

  useEffect(() => {
    if (listing !== null) {
      let clone: any = {};
      Object.assign(clone, abonnement);
      clone.description_long = listing;
      setAbonnement(clone);
    }
  }, [listing]);

  useEffect(() => {
    if (_editAbonnement.success === "" || !abonnementPending) {
      return;
    }
    if (_editAbonnement.success === true) {
      showNotification("success", _editAbonnement.data.id);
      setItem("contingent", "");
      close();
    } else {
      showNotification("warning", null, t(_editAbonnement.data.message));
    }
    setAbonnementPending(false);
  }, [_editAbonnement]);

  const onSubmit = () => {
    let errmsg = t("Please enter the following fields: ");
    let errors = [];
    if (abonnement.description === "") {
      $(".abonnement_description_input input").css("border-color", "red");
      errors.push(t("abonnement description", null, "capital"));
    }
    if (abonnement.intervalAmount === null) {
      $(".abonnement_interval_amount_input input").css("border-color", "red");
      errors.push(t("interval amount", null, "capital"));
    }
    if (abonnement.amount === null) {
      $(".abonnement_amount_input input").css("border-color", "red");
      errors.push(t("amount", null, "capital"));
    }
    if (errors.length > 0) {
      showNotification("warning", null, errmsg + errors.join(", "));
      return;
    }
    let clone = {};
    Object.assign(clone, abonnement);

    if (typeof abonnement.id === "undefined") {
      addAbonnement({ dispatch: dispatch, abonnement: clone });
      setAbonnementPending(true);
    } else {
      editAbonnement({ dispatch: dispatch, abonnement: clone });
      setAbonnementPending(true);
    }
  };

  const getUnit = (unit: any): string => {
    if (typeof unit === "string") {
      return unit;
    }
    try {
      return unit.toString();
    } catch (e: any) {
      return "";
    }
  };
  const getAmount = (unit: any): number => {
    if (typeof unit === "string") {
      return parseInt(unit);
    }
    if (typeof unit === "number") {
      return unit;
    }
    try {
      return parseInt(unit);
    } catch (e: any) {
      return 0;
    }
  };

  const onChangeField = (e: any, name: string | undefined) => {
    let clone: any = {};
    Object.assign(clone, abonnement);
    if (typeof name === "undefined") {
      name = "";
    }
    if (name === "description" && e.target.value !== "") {
      $(".abonnement_description_input input").css("border-color", "rgb(227, 227, 227)");
    }
    if (
      !in_array(name, ["durationAmount", "durationUnit", "minDurationAmount", "minDurationUnit"])
    ) {
      clone[name] = e.target.value;
    }
    if (name === "durationAmount" && e.target.value !== "") {
      if ($(".abonnement_duration_unit select").val() === t("switch")) {
        clone["duration"] = e.target.value;
      } else {
        let unit: string = getUnit($(".abonnement_duration_unit select").val());
        let amount: number = getAmount(e.target.value);
        clone["duration"] = getDurationReverse(amount, unit);
      }
    }
    if (name === "durationUnit" && e.target.value !== "") {
      if (e.target.value === null) {
        let unit: string = "";
        let amount: number = getAmount($(".abonnement_duration_amount input").val());
        clone["duration"] = getDurationReverse(amount, unit);
      } else {
        let unit: string = getUnit(e.target.value);
        let amount: number = getAmount($(".abonnement_duration_amount input").val());
        clone["duration"] = getDurationReverse(amount, unit);
      }
    }
    if (name === "minDurationAmount" && e.target.value !== "") {
      if ($(".abonnement_min_duration_unit select").val() === t("switch")) {
        clone["minDuration"] = e.target.value;
      } else {
        let unit: string = getUnit($(".abonnement_min_duration_unit select").val());
        let amount: number = getAmount(e.target.value);
        clone["minDuration"] = getDurationReverse(amount, unit);
      }
    }
    if (name === "minDurationUnit" && e.target.value !== "") {
      if (e.target.value === null) {
        let unit: string = "";
        let amount: number = getAmount($(".abonnement_min_duration_amount input").val());
        clone["minDuration"] = getDurationReverse(amount, unit);
      } else {
        let unit: string = getUnit(e.target.value);
        let amount: number = getAmount($(".abonnement_min_duration_amount input").val());
        clone["minDuration"] = getDurationReverse(amount, unit);
      }
    }
    setAbonnement(clone);
  };

  const onChangeMembershipType = (e: any) => {
    let clone: any = {};
    Object.assign(clone, abonnement);
    if (e.target.value !== null) {
      $(".membershiptype_select select").css("border-color", "rgb(227, 227, 227)");
    }
    clone.membership_type_id = e.target.value;
    setAbonnement(clone);
  };

  const closeNotification = () => {
    setNotification({
      ...notification,
      show: false,
    });
  };
  const currentUrl: any = new URL(window.location.href);
  const close = () => {
    dispatch(abonnementsActions.getAbonnementResetData());
    dispatch(abonnementsActions.getAbonnementsResetData());
    setItem("abonnement", "");
    let returnUrl =
      typeof requestPath !== "undefined" &&
      requestPath !== "/abonnements/add" &&
      typeof abonnement.id !== "undefined" &&
      requestPath !== "/abonnements/" + abonnement.id
        ? requestPath + currentUrl.search
        : `/abonnements${currentUrl.search}`;
    window.location.replace(returnUrl);
  };

  const abortButtonRef: any = React.createRef();
  const dateTimes: any = [
    {
      id: null,
      name: t("switch"),
    },
    {
      id: "day",
      name: t("day"),
    },
    {
      id: "days",
      name: t("days"),
    },
    {
      id: "week",
      name: t("week"),
    },
    {
      id: "weeks",
      name: t("weeks"),
    },
    {
      id: "month",
      name: t("month"),
    },
    {
      id: "months",
      name: t("months"),
    },
    {
      id: "year",
      name: t("year"),
    },
    {
      id: "years",
      name: t("years"),
    },
  ];

  const onChangeImage = (e: any) => {
    let clone: any = {};
    Object.assign(clone, abonnement);
    clone.image = e.target.value;
    console.log(clone);
    setAbonnement(clone);
    setImage(e.target.value);
  };
  const aboCard = (e: any) => {};
  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"> </div>
      {notification.show && (
        <>
          <Notification
            message={notification.message}
            onCloseHandler={closeNotification}
          ></Notification>
        </>
      )}
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {abonnement !== null && abonnement.id !== undefined && abonnement.id !== ""
              ? t("edit_${a}", { a: t("Abonnement") })
              : t("add_${a}", { a: t("Abonnement") })}
          </h1>
          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save")}
              onClick={onSubmit}
            >
              {!abonnementPending && (
                <>
                  <i className="fi fi-check"> </i>
                  <span>{t("save")}</span>
                </>
              )}
              {abonnementPending && (
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader"
                    src={"assets/img/rolling_loader.svg"}
                  />
                  {t("save")}
                </span>
              )}
            </button>
            <a href="#">
              <button
                ref={abortButtonRef}
                type="button"
                id="inb-tasksform-abort-button"
                className="button hollow secondary right button-abort round"
                title={t("close_window")}
                onClick={() => close()}
              >
                <i className="fi fi-x"> </i>
              </button>
            </a>
          </div>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
          {typeof abonnement.created !== "undefined" &&
            t("created_at") +
              " " +
              moment(abonnement.created).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              abonnement.created_by_name +
              " | " +
              t("last_modified_at") +
              " " +
              moment(abonnement.modified).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              abonnement.modified_by_name}
        </p>
        <form className="off-content row">
          <FormItem
            name="description"
            inputType="text"
            id={
              "abonnement_description_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={t("description", null, "capital")}
            type="input"
            value={abonnement.description}
            mediumWidth={12}
            smallWidth={12}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            disabled={Biscuit.get("user.role") === "manager"}
            extraTopClasses="abonnement_description_input"
          />
          <FormItem
            name="intervalAmount"
            inputType="text"
            id={
              "abonnement_interval_amount_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={t("interval", null, "capital")}
            type="input"
            value={abonnement.intervalAmount}
            mediumWidth={3}
            smallWidth={3}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            disabled={Biscuit.get("user.role") === "manager"}
            notTiny={true}
            extraTopClasses=""
          />
          <FormItem
            name="intervalUnit"
            inputType="select"
            style={{ paddingTop: "30px" }}
            id={
              "abonnement_interval_unit_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label=" "
            type="select"
            dataKey="id"
            data={dateTimes}
            disabled={Biscuit.get("user.role") === "manager"}
            selected={abonnement.intervalUnit !== null ? abonnement.intervalUnit : null}
            mediumWidth={3}
            smallWidth={3}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses=""
          />
          <FormItem
            name="minDurationAmount"
            inputType="text"
            id={
              "abonnement_min_duration_amount_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={t("minimal duration", null, "capital")}
            type="input"
            value={
              abonnement.minDuration !== null
                ? getDuration(abonnement.minDuration, true, false)
                : null
            }
            mediumWidth={3}
            smallWidth={3}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            disabled={Biscuit.get("user.role") === "manager"}
            notTiny={true}
            extraTopClasses="abonnement_min_duration_amount"
          />
          <FormItem
            name="minDurationUnit"
            inputType="select"
            style={{ paddingTop: "30px" }}
            id={
              "abonnement_min_duration_unit_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={" "}
            type="select"
            dataKey="id"
            data={dateTimes}
            disabled={Biscuit.get("user.role") === "manager"}
            selected={
              abonnement.minDuration !== null
                ? getDuration(abonnement.minDuration, false, true)
                : null
            }
            mediumWidth={3}
            smallWidth={3}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="abonnement_min_duration_unit"
          />
          <FormItem
            name="durationAmount"
            inputType="text"
            id={
              "abonnement_duration_amount_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={t("duration", null, "capital")}
            type="input"
            value={
              abonnement.duration !== null ? getDuration(abonnement.duration, true, false) : null
            }
            mediumWidth={3}
            smallWidth={3}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            disabled={Biscuit.get("user.role") === "manager"}
            notTiny={true}
            extraTopClasses="abonnement_duration_amount"
          />
          <FormItem
            name="durationUnit"
            inputType="select"
            style={{ paddingTop: "30px" }}
            id={
              "abonnement_duration_unit_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={" "}
            type="select"
            dataKey="id"
            data={dateTimes}
            disabled={Biscuit.get("user.role") === "manager"}
            selected={
              abonnement.duration !== null ? getDuration(abonnement.duration, false, true) : null
            }
            mediumWidth={3}
            smallWidth={3}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="abonnement_duration_unit"
          />
          <FormItem
            name="membership_types_id"
            inputType="text"
            id={
              "abonnement_membership_type_id_" +
              (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={t("usergroup", null, "capital")}
            type="select"
            dataKey="id"
            data={membershipTypes}
            selected={abonnement.membership_types_id !== null ? abonnement.membership_types_id : ""}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            disabled={Biscuit.get("user.role") === "manager"}
            notTiny={true}
            extraTopClasses=""
          />
          <FormItem
            name="amount"
            inputType="text"
            id={
              "abonnement_amount_" + (typeof abonnement.id !== "undefined" ? abonnement.id : "new")
            }
            label={t("amount", null, "capital")}
            type="input"
            value={abonnement.amount}
            mediumWidth={2}
            smallWidth={2}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            disabled={Biscuit.get("user.role") === "manager"}
            notTiny={true}
            extraTopClasses=""
          />

          <ImageUpload
            onChange={onChangeImage}
            image={image}
            type="abonnement"
            clientId={Biscuit.get("user.client_id")}
            setImage={setImage}
            dispatch={dispatch}
            showPreview={false}
          />
          <br />
          <div style={{ width: "100%", float: "left" }}>
            <div style={{ width: "20%", float: "left" }}>
              <span
                style={{ fontSize: "24px", marginTop: "50%", marginRight: "20px", float: "right" }}
              >
                {t("preview")}
              </span>
            </div>
            <div style={{ width: "50%", float: "left" }}>
              <AbonnementCard
                type={"available"}
                title={abonnement.description}
                description={outer}
                image={image || abonnement.image || " "}
                amount={abonnement.amount}
                interval={getIntervalString(abonnement.intervalAmount, abonnement.intervalUnit, t)}
                appCurrency={Biscuit.get("client.currency").replace("EUR", "€")}
                buttonOnClick={aboCard}
                id={abonnement.id !== null ? abonnement.id : "new"}
                minDuration={getMinDuration(abonnement.minDuration, t)}
              />
            </div>
          </div>
          <Listing
            value={listing}
            setValue={setListing}
            title={t("description details")}
            mediumWidth={12}
            smallWidth={12}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
          />
        </form>
      </div>
    </>
  );
};

export default ItemView;
